import { render, staticRenderFns } from "./UTMEDetails.vue?vue&type=template&id=359a6fea&scoped=true"
import script from "./UTMEDetails.vue?vue&type=script&lang=js"
export * from "./UTMEDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359a6fea",
  null
  
)

export default component.exports